<div class="portlet-title" *ngIf="!isList && !breadcrumbsData">
  <div class="caption" style="display: flex; justify-content: space-between;align-items: baseline">
    <div class="caption-subject bold">
      <i *ngIf="!orderType" class="fal {{icon}}"></i>&nbsp;
      <ng-content select="[order-type]"></ng-content>
      <span>{{ title | translate:locale.language}}</span>
      <span *ngIf="isEdit">{{ titleRef | translate:locale.language}}</span>
    </div>
<!--    <ng-content select="[order-status]"></ng-content>-->
  </div>

  <div *ngIf="buttonTitle" class="actions fa-pull-right" style="position: relative; margin-top: -32px;">
    <storever-action-button *ngIf="buttonRole ? (isInRole$(buttonRole) | async) : true"
      [buttonTitle]="buttonTitle"
      [buttonIcon]="buttonIcon"
      (actions)="this.actions()"
    ></storever-action-button>
  </div>
  <div *ngIf="buttonTitleExtra" class="actions fa-pull-right" style="position: relative; top: -30px;margin-right: 7px">
    <storever-action-button
      [buttonTitle]="buttonTitleExtra"
      [buttonIcon]="buttonIconExtra"
      (actions)="this.actionsExtra()"
    ></storever-action-button>
  </div>
</div>

<div class="portlet-title"  *ngIf="isList && !breadcrumbsData">
  <div class="caption" style="display: flex; justify-content: space-between;align-items: baseline">
    <div class="caption-subject bold">
        <span *ngFor="let item of data">
                <i  class="fal {{item.icon}}"></i>&nbsp;
                <ng-container *ngIf="item.href; else labelItem">
                  <a [href]="item.href">{{ item.text | translate:locale.language}}</a>
                </ng-container>
                <ng-template #labelItem>
                  <span>{{ item.text | translate:locale.language}}</span>
                </ng-template>
        </span>
    </div>
    <ng-content></ng-content>
  </div>
  <div *ngIf="buttonTitle" class="actions fa-pull-right" style="position: relative; top: -30px;">
    <storever-action-button  *ngIf="buttonRole ? (isInRole$(buttonRole) | async) : true"
      [buttonTitle]="buttonTitle"
      [buttonIcon]="buttonIcon"
      (actions)="this.actions()"
    ></storever-action-button>
  </div>
  <div *ngIf="buttonTitleExtra" class="actions fa-pull-right" style="position: relative; top: -30px;margin-right: 7px">
    <storever-action-button
      [buttonTitle]="buttonTitleExtra"
      [buttonIcon]="buttonIconExtra"
      (actions)="this.actionsExtra()"
    ></storever-action-button>
  </div>
</div>

<div class="portlet-title"  *ngIf="breadcrumbsData">
  <div class="caption" style="display: flex; justify-content: space-between;align-items: baseline">
    <div class="caption-subject" style="font-size: 15px">
        <span *ngFor="let item of breadcrumbsData">
           <storever-breadcrums
             [icon]="item.icon"
             [title]="item.title"
             [list]="item.listData"
             [filterVue]="item.filterVue"
             [filterValue]="item.filterValue"
             [filterPlaceholder]="item.filterPlaceholder"
             (redirectName)="this.redirectName(item.type)"
             (redirectList)="this.redirectList(item.type , $event)"
           ></storever-breadcrums>
        </span>
    </div>
    <ng-content></ng-content>
  </div>
  <div *ngIf="buttonTitle" class="actions fa-pull-right" style="position: relative; top: -30px;"
       tooltip="{{ (!allowOrderCreation ? 'Please use SalesForce to create new order' :'')  | translate:locale.language}}"
       [tooltipPlacement]="'bottom'"
  >
    <span  [class.disabled]="!allowOrderCreation">
    <storever-action-button  *ngIf="buttonRole ? (isInRole$(buttonRole) | async) : true"
      [buttonTitle]="buttonTitle"
      [buttonIcon]="buttonIcon"
      (actions)="this.actions()"
    ></storever-action-button>
    </span>
  </div>
  <div *ngIf="buttonTitleExtra" class="actions fa-pull-right" style="position: relative; top: -30px;margin-right: 7px">
    <storever-action-button
      [buttonTitle]="buttonTitleExtra"
      [buttonIcon]="buttonIconExtra"
      (actions)="this.actionsExtra()"
    ></storever-action-button>
  </div>
</div>
